import { Component, OnInit, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink, RouterLinkActive, RouterModule } from "@angular/router";
import { DataService } from "../../services/data.service";
import { SiteData } from "../../models/site-data.model";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [CommonModule, RouterModule, RouterLinkActive, RouterLink],
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  private dataService = inject(DataService);
  siteData: SiteData | null = null;
    // Sample data to loop through
  partners = [
    { id: '4', src: '../../../assets/partners/img-4.png', alt: 'Image 4', title: 'Slide 4' },
    { id: '1', src: '../../../assets/partners/img-1.jpg', alt: 'Image 1', title: 'Slide 1' },
    { id: '2', src: '../../../assets/partners/img-2.webp', alt: 'Image 2', title: 'Slide 2' },
    { id: '3', src: '../../../assets/partners/img-3.jpeg', alt: 'Image 3', title: 'Slide 3' },
    { id: '5', src: '../../../assets/partners/img-5.png', alt: 'Image 5', title: 'Slide 5' },
    { id: '5', src: '../../../assets/partners/img-6.png', alt: 'Image 6', title: 'Slide 6' },
    { id: '5', src: '../../../assets/partners/img-7.png', alt: 'Image 7', title: 'Slide 7' },
    { id: '5', src: '../../../assets/partners/img-8.png', alt: 'Image 8', title: 'Slide 8' },
  ];
  ngOnInit() {
    this.dataService.getSiteData().subscribe((data) => {
      this.siteData = data;
    });
  }

  scrollToSection(url: string) {
    if (url.startsWith("#")) {
      const element = document.querySelector(url);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  /**
   * Open email client with mailto: link
   */
  openEmail(email: string): void {
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  }

  /**
   * Open phone dialer with tel: link
   */
  openPhone(phone: string): void {
    if (phone) {
      // Remove any non-digit characters except + for international numbers
      const cleanPhone = phone.replace(/[^\d+]/g, "");
      window.location.href = `tel:${cleanPhone}`;
    }
  }

  /**
   * Open Google Maps in new tab with the address
   */
  openGoogleMaps(address: string): void {
    if (address) {
      const encodedAddress = encodeURIComponent(address);
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
      window.open(googleMapsUrl, "_blank", "noopener,noreferrer");
    }
  }

  /**
   * Extract first email from content string
   */
  getFirstEmail(content: string): string {
    if (!content) return "";
    // Extract email from HTML content
    const emailMatch = content.match(/[\w\.-]+@[\w\.-]+\.\w+/);
    return emailMatch ? emailMatch[0] : "";
  }

  /**
   * Extract first phone number from content string
   */
  getFirstPhone(content: string): string {
    if (!content) return "";
    // Remove HTML tags and extract first phone number
    const textContent = content
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/<[^>]*>/g, "");
    // Match phone numbers (Egyptian format: starts with 0 or +20)
    const phoneMatch = textContent.match(/(?:0|\+20)?\d{10,11}/);
    return phoneMatch ? phoneMatch[0] : "";
  }
}
